import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { NumpadDisplayService } from 'packages/sports/web/app/src/numpad/numpad-display.service';
import { Observable, map, merge, pairwise, startWith } from 'rxjs';

import { IBetslipRootState } from '../../../base/store/state';
import { QUICK_BET_NUMPAD } from '../../stake/models';
import { selectQuickBetPickNotificationState } from '../quick-bet.selectors';
import { QuickBetUtils } from './quick-bet-utils.service';

@Injectable()
export class QuickBetAutoScrollingService {
    readonly shouldAutoScroll$: Observable<boolean>;

    constructor(
        private numpadDisplayService: NumpadDisplayService,
        private store: Store<IBetslipRootState>,
        private quickBetUtils: QuickBetUtils,
    ) {
        const notificationTrigger$ = this.buildNotificationTrigger();
        const numpadTrigger$ = this.buildNumpadTrigger();

        this.shouldAutoScroll$ = merge(numpadTrigger$, notificationTrigger$);
    }

    private buildNumpadTrigger(): Observable<boolean> {
        return this.numpadDisplayService.open$.pipe(map((x) => x.id === QUICK_BET_NUMPAD));
    }

    private buildNotificationTrigger(): Observable<boolean> {
        return this.store.select(selectQuickBetPickNotificationState).pipe(
            map(({ quickBet, picksList, oddsAcceptance, errorState }) => {
                const errorsStatus = errorState;
                const oddsAccepted = this.quickBetUtils.areOddsAccepted(picksList, quickBet.pickIds, oddsAcceptance);

                if (!oddsAccepted) {
                    errorsStatus.oddsChanged = true;
                }

                const hasCurrentErrors =
                    errorsStatus.oddsChanged || quickBet.oddsChangedOnBetPlacement || errorsStatus.isLocked || quickBet.pickLockedOnBetPlacement;

                return hasCurrentErrors;
            }),
            startWith(false),
            pairwise(),
            map(([hadPreviousErrors, hasCurrentErrors]) => !hadPreviousErrors && hasCurrentErrors),
        );
    }
}
